var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nav-submenu-box" }, [
    _c("div", { staticClass: "logo_left" }),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "el-menu",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.$route.path !== "/index",
                expression: "$route.path !== '/index'"
              }
            ],
            staticClass: "el-menu-vertical-demo",
            staticStyle: { height: "100%", width: "100%" },
            attrs: {
              mode: "horizontal",
              "unique-opened": true,
              "default-active": this.$route.path
            },
            on: { select: _vm.selectMenu }
          },
          [
            _vm._l(_vm.list, function(item, index) {
              return [
                _c(
                  "el-menu-item",
                  { key: index, attrs: { index: item.path } },
                  [
                    _c("template", { slot: "title" }, [
                      _c(
                        "span",
                        { style: item.name == "交易中心" ? "color:#ccc" : "" },
                        [_vm._v(_vm._s(item.name))]
                      )
                    ])
                  ],
                  2
                )
              ]
            })
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo_right" }, [
      _c("div", { staticClass: "img" }, [
        _c("img", {
          attrs: {
            src: require("../assets/images/latast_pc/pcLogo_right.png"),
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "txt" }, [_vm._v("sssss")]),
      _vm._v(" "),
      _c("div", { staticClass: "icon" }, [
        _c("i", { staticClass: "el-icon-arrow-down" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4523f0fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4523f0fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuListForDark.vue
// module id = null
// module chunks = 